export const FETCH_ALL_USER_CASES = 'FETCH_ALL_USER_CASES';
export const FETCH_ALL_USER_CASES_START = 'FETCH_ALL_USER_CASES_START';
export const FETCH_ALL_USER_CASES_SUCCESS = 'FETCH_ALL_USER_CASES_SUCCESS';
export const FETCH_ALL_USER_CASES_ERROR = 'FETCH_ALL_USER_CASES_ERROR';
export const ALL_CASES_PAGINATION = 'ALL_CASES_PAGINATION';
export const SET_ALL_CASES_FILTER = 'SET_ALL_CASES_FILTER';

export const ADD_USER_CASE_TO_MY_LIBRARY = '[ALL_CASES] ADD_USER_CASE_TO_MY_LIBRARY';
export const ADD_USER_CASE_TO_MY_LIBRARY_SUCCESS = '[ALL_CASES] ADD_USER_CASE_TO_MY_LIBRARY_SUCCESS';
export const ADD_USER_CASE_TO_MY_LIBRARY_ERROR = '[ALL_CASES] ADD_USER_CASE_TO_MY_LIBRARY_ERROR';

export const FETCH_USER_CASES_BY_REPORT_ID = 'FETCH_USER_CASES_BY_REPORT_ID';
export const FETCH_USER_CASES_BY_REPORT_ID_START = 'FETCH_USER_CASES_BY_REPORT_ID_START';
export const FETCH_USER_CASES_BY_VISIT_ID_SUCCESS = 'FETCH_USER_CASES_BY_VISIT_ID_SUCCESS';
export const FETCH_USER_CASES_BY_REPORT_ID_ERROR = 'FETCH_USER_CASES_BY_REPORT_ID_ERROR';

export const fetchAllUserCases = (payload) => {

    return {
        type: FETCH_ALL_USER_CASES,
        payload
    };
};


export const addAllCasesUserCaseToMyLibrary = (payload) => {
    return {
        type: ADD_USER_CASE_TO_MY_LIBRARY,
        payload
    };
}

export const fetchUserCasesByReportId = (payload) => {
    return {
        type: FETCH_USER_CASES_BY_REPORT_ID,
        payload
    };
}